import React from 'react';
import Icon from '../../../components/AppIcon';

const SuccessMetrics = ({ service }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-8 border border-primary/10">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-foreground mb-2">
          Proven Results
        </h3>
        <p className="text-muted-foreground">
          Our track record speaks for itself
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {service.metrics.map((metric, index) => (
          <div key={index} className="text-center">
            <div className="w-16 h-16 rounded-full gradient-primary flex items-center justify-center mx-auto mb-4">
              <Icon name={metric.icon} size={24} color="white" />
            </div>
            
            <div className="text-3xl font-bold text-foreground mb-2">
              {metric.value}
            </div>
            
            <div className="text-sm font-medium text-primary mb-1">
              {metric.label}
            </div>
            
            <div className="text-xs text-muted-foreground">
              {metric.description}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 pt-8 border-t border-primary/20">
        <div className="grid md:grid-cols-3 gap-6 text-center">
          {service.achievements.map((achievement, index) => (
            <div key={index} className="flex items-center space-x-3">
              <div className="w-8 h-8 rounded-full bg-success/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Award" size={16} className="text-success" />
              </div>
              <div className="text-left">
                <div className="font-semibold text-foreground text-sm">
                  {achievement.title}
                </div>
                <div className="text-xs text-muted-foreground">
                  {achievement.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessMetrics;